import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openSnackbar } from 'redux/snackbar/actions';
import { toggleUserDialog, fetchTags } from 'redux/tags/actions';
import { selectTags, getSelectedUsers, selectAddTagDialog } from 'redux/tags/selectors';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import api from 'api';

import DialogApp from 'components/DialogApp';
import Layout from './Layout';

class AddTag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actionValue: 'existing',
      disableActionButton: false,
      existingTagValue: '',
      newTagValue: '',
    };

    this.onChange = this.onChange.bind(this);
    this.handleAddTag = this.handleAddTag.bind(this);
    this.addTagSuccess = this.addTagSuccess.bind(this);
    this.addTagFailure = this.addTagFailure.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.didOpen(prevProps)) this.setDefaultTag();
    if (this.didOpen(prevProps)) this.disableEnableButton();
  }

  didOpen(prevProps) {
    const { open: prevOpen } = prevProps;
    const { open: currentOpen } = this.props;
    return currentOpen && !prevOpen;
  }

  disableEnableButton() {
    this.setState({ disableActionButton: false });
  }

  disableActionButton() {
    this.setState({ disableActionButton: true });
  }

  setDefaultTag() {
    const existingTagValue = get(this.props, 'tags[0].id', '');
    this.setState({ existingTagValue });
  }

  handleAddTag() {
    const { actionValue } = this.state;
    this.disableActionButton();

    if (actionValue === 'existing') this.addExistingTag();
    else if (actionValue === 'new') this.addNewTag();
  }

  addExistingTag() {
    const { existingTagValue } = this.state;
    const { tags, selectedUsers } = this.props;
    const tagId = parseInt(existingTagValue, 10);
    const selectedTag = tags.find(tag => tag.id === tagId);
    if (!selectedTag) return false;

    this.createTag(selectedTag.name, selectedUsers);
  }

  addNewTag() {
    const { newTagValue } = this.state;
    const { selectedUsers } = this.props;
    if (!newTagValue) return false;

    this.createTag(newTagValue, selectedUsers);
  }

  createTag(tag_name, usersId) {
    api.createTag({
      tag_name,
      usersId,
      cb: this.addTagSuccess,
      cbError: this.addTagFailure,
    });
  }

  addTagSuccess() {
    this.props.toggleDialog();
    this.props.openAppSnackbar('Tag added successfully');
    this.props.fetchTags();
  }

  addTagFailure() {
    this.props.toggleDialog();
    this.props.openAppSnackbar('Tag was not added');
  }

  onChange(event) {
    const value = get(event, 'target.value');
    const name = get(event, 'target.name');

    this.setState({ [name]: value });
  }

  render() {
    const { open, toggleDialog, selectedUsers, tags } = this.props;
    const { disableActionButton, existingTagValue, actionValue, newTagValue } = this.state;

    return (
      <DialogApp
        open={open}
        onClose={toggleDialog}
        small
      >
        <Layout
          selectedUsers={selectedUsers}
          toggleDialog={toggleDialog}
          disableActionButton={disableActionButton}
          handleAddTag={this.handleAddTag}
          onChange={this.onChange}
          tags={tags}
          actionValue={actionValue}
          newTagValue={newTagValue}
          existingTagValue={existingTagValue}
        />
      </DialogApp>
    );
  }
}

const mapStateToProps = state => ({
  tags: selectTags(state),
  selectedUsers: getSelectedUsers(state),
  open: selectAddTagDialog(state),
});


AddTag.propTypes = {
  open: PropTypes.bool.isRequired,
  tags: PropTypes.array.isRequired,
  selectedUsers: PropTypes.array.isRequired,
};

export default connect(
  mapStateToProps, { toggleDialog: toggleUserDialog, openAppSnackbar: openSnackbar, fetchTags },
)(AddTag);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/AddTag/AddTag.jsx